// 文档链接配置
import React from 'react';

const DOC_DOMAIN = 'https://docs.bugly.woa.com';

export default {
  docRoot: DOC_DOMAIN,
  quickStart: `${DOC_DOMAIN}/quick_start`,
  relateProduct: `${DOC_DOMAIN}/quick_start/relate_product`,
  buglyQQMessage: <span>如果你之前已经在Bugly QQ上注册过相同产品，请选择对应产品的APPID。更多细节请查看<a target={'_blank'} href={`${DOC_DOMAIN}/quick_start/relate_product`}>《关联Bugly QQ的相同产品指引》</a></span>,
  alarmQuickStart: `${DOC_DOMAIN}/tutorial/alarm/#%E5%91%8A%E8%AD%A6%E9%80%9A%E7%9F%A5`,
  configQuickStart: `${DOC_DOMAIN}/tutorial/config/`,
  uuidDoc: `${DOC_DOMAIN}/feature/symbol/uuid`,
  searchDoc: `${DOC_DOMAIN}/feature/analysis/search/`,
  iosExitDoc: `${DOC_DOMAIN}/feature/iOS/appexit`,
  iosTickInfoDoc: `${DOC_DOMAIN}/feature/iOS/appexit#tick-info`,
  iosExitInfoDoc: `${DOC_DOMAIN}/feature/iOS/appexit#exit-info`,
  iosVmmapInfoDoc: `${DOC_DOMAIN}/feature/iOS/appexit#vmmap-info`,
  androidApplicationExitInfo: 'https://developer.android.com/reference/android/app/ApplicationExitInfo',
  dominatortreeDoc: 'https://help.eclipse.org/latest/index.jsp?topic=%2Forg.eclipse.mat.ui.help%2Fconcepts%2Fdominatortree.html',
  androidNetDoc: `${DOC_DOMAIN}/feature/Android/net_quality/`,
  iosNetDoc: `${DOC_DOMAIN}/feature/iOS/network_monitor`,
  relatedBuglyqqDoc: '',
  attachmentDoc: `${DOC_DOMAIN}/analysis/attachment/`,
  guideDoc: `${DOC_DOMAIN}/analysis/metric/guide`,
  otherUploadMethodsDoc: `${DOC_DOMAIN}/quick_start/symbol/tool`,
  symbolGuideDoc: `${DOC_DOMAIN}/quick_start/symbol/guide/`,
  qualityReport: `${DOC_DOMAIN}/analysis/quality_report/`,
  electronGuid: `${DOC_DOMAIN}/electron/quick_start/`,
  alertGuide: `${DOC_DOMAIN}/quick_start/alert/guide`,
  customDataDoc: `${DOC_DOMAIN}/analysis/custom_data/#自定义维度`,
  alarmNotificationDoc: `${DOC_DOMAIN}/quick_start/alert/alert_notice`,
};
